import { render } from "./CertificateSection.vue?vue&type=template&id=47493443"
import script from "./CertificateSection.vue?vue&type=script&lang=js"
export * from "./CertificateSection.vue?vue&type=script&lang=js"

import "./CertificateSection.vue?vue&type=style&index=0&id=47493443&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__